<template>
  <div v-bind="$attrs">
    <header v-if="headline" class="mb-4">
      <h2 class="text-2xl font-semibold text-blue-500">{{ headline }}</h2>
    </header>
    <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-10 items-start">
      <template v-for="(item, key) in items" :key="item.id">
        <Card
          :caption="item.name"
          :image="item.cover"
          :link="route('vouchers.show', [item])"
          :alt="item.cover.metadata?.alt ?? item.name"
        >
          <template #footer>
            <strong class="text-xl text-blue-500 mb-4 sm:mb-0">
              {{ price(item) }}
            </strong>
            <Link
              :href="route('vouchers.show', [item])"
              class="button button--ghost text-blue-500 ml-auto w-full sm:w-auto"
              text="Mehr erfahren"
            />
          </template>
        </Card>
      </template>
    </div>
  </div>
</template>

<script>
import formatPrice from '@/helpers/formatPrice';
import Card from 'Web/Shared/Card.vue';
import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    Card,
    Link,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    headline: {
      type: String,
      default: 'Gutscheine',
    },
  },
  setup() {
    function price(item) {
      let priceRange = item.options && item.options.length;
      let price;

      if (priceRange) {
        price = Math.min(...item.options.map(option => option.price));
        return 'ab ' + formatPrice(price);
      }

      return formatPrice(price);
    }

    return {
      formatPrice,
      price,
    }
  }
}
</script>
